import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Aux from '../../../components/Hoc/Aux';
import DocSearch from '../../../components/DocSearch/DocSearch.jsx';
import ReasonsMedicaid from '../../../components/Reasons/ReasonsMedicaid';

class ChildHealthPlus extends Component {
  componentDidMount () {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'visitorType': 'Prospect - CHP',
      'event': 'GAEvent',
      'eventCategory': 'View',
      'eventAction': 'Landing',
      'eventLabel': 'Plans - CHP',
      'eventValue': undefined
    });
  }

  render () {
    return (
      <Aux>
        <ReasonsMedicaid classes='divider p60' headline='true' chp='true' />
        <DocSearch search='https://findadoc.cdphp.com/?PlanType=Child Health Plus' />
        <section className='divide p60'>
          <div className='wrap'>
            <h2>Find out if you qualify.</h2>
            <ul className='inline'>
              <li><Link to='/child-health-plus/find-a-plan/' className='btn alt'>Get Started</Link></li>
            </ul>
          </div>
        </section>
      </Aux>
    );
  }
}

ChildHealthPlus.propTypes = { // validate props expected
};

export default ChildHealthPlus;



// WEBPACK FOOTER //
// ./src/containers/Views/Landing/ChildHealthPlus.jsx